var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cly-vue-form-col py-8 px-6",class:{'cly-vue-form-col--border': _vm.border }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }